import { fetchQuoteBiddingDetails } from '@views/screens/Quote/data-provider/quote-bidding-details';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useGetQuoteBiddingDetails = (quoteKey: string) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    enabled: Boolean(quoteKey),
    queryFn: () => fetchQuoteBiddingDetails(quoteKey),
    queryKey: ['quote-bidding-details', quoteKey],
    staleTime: 1000 * 5, // 5 seconds (to avoid multiple calls)
  });

  const fetchQuoteBidders = async () => {
    const data = await queryClient.query({
      queryFn: () => fetchQuoteBiddingDetails(quoteKey),
      queryKey: ['quote-bidding-details', quoteKey],
    });

    return data;
  };

  return { ...query, fetchQuoteBidders };
};
